import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import CustomButton from "../other/common/CustomButton";
import deepakSharmaImg from "../../assets/images/webp/other/deepak-sharma-three-img.webp";

const HeroThree = () => {
  return (
    <>
      <div className="flex items-center justify-center bg-cover bg-no-repeat bg-center bg-motivational-speaker-bg">
        <div className="w-full max-w-[1140px] px-3 flex flex-col lg:flex-row items-center relative">
          <div className="py-[120px] max-xl:py-24 max-lg:py-20 max-md:py-10 max-w-[738px] w-full z-10">
            <BlueHeading
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
              text="His History"
              textClass="!text-white"
            />
            <h2 className="text-6xl max-xl:text-[50px] max-lg:text-5xl max-md:text-4xl max-sm:text-3xl font-bold ff-jakarta leading-[120%] text-white pt-3 max-w-[738px]">
              From Village Roots to Visionary Heights
            </h2>
            <h3 className="ff-jakarta text-xl font-bold leading-[150%] text-white py-4">
              Entrepreneur | Motivational | Speaker | Founder{" "}
            </h3>
            <p className="text-[#DDDDDD] font-medium text-base leading-[150%] max-w-[585px]">
              <u>Deepak Sharma</u> is not just a name – he is a living proof
              that your background doesn’t define your future. Born and raised
              in a small Indian village, without fluency in English, without
              financial support, and with no urban privileges – Deepak chose to
              rewrite his destiny.
            </p>
            <CustomButton
              myClass="!text-black !bg-white mt-10 hover:!text-white hover:!bg-[#241DB6]"
              text="Watch His Story"
            />
          </div>

          <div className="w-full max-w-[585px] h-[652px] max-xl:h-[500px] max-lg:h-[400px] max-sm:h-[370px] lg:absolute lg:right-0 bottom-[-30px] max-xl:bottom-0 z-0">
            <img
              src={deepakSharmaImg}
              alt="deepak-sharma"
              width={585}
              height={652}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroThree;
